import {ComponentProps} from "react";

interface IProps extends ComponentProps<"path"> {
  color?: string;
}

const StarDropdownIcon = ({color = "#E01313", ...props}: IProps) => (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M4.23211 5.61763C2.26416 6.06323 1.28018 6.28563 1.04579 7.03844C0.812192 7.79044 1.48258 8.57525 2.82415 10.1441L3.17134 10.5497C3.55213 10.9953 3.74332 11.2185 3.82892 11.4937C3.91452 11.7697 3.88572 12.0673 3.82812 12.6617L3.77532 13.2033C3.57293 15.2969 3.47133 16.3433 4.08412 16.8081C4.6969 17.2729 5.61848 16.8489 7.46004 16.0009L7.93762 15.7817C8.46081 15.5401 8.72241 15.4201 9 15.4201C9.27759 15.4201 9.53919 15.5401 10.0632 15.7817L10.5392 16.0009C12.3815 16.8489 13.3031 17.2729 13.9151 16.8089C14.5287 16.3433 14.4271 15.2969 14.2247 13.2033M15.1759 10.1441C16.5174 8.57605 17.1878 7.79124 16.9542 7.03844C16.7206 6.28563 15.7358 6.06243 13.7679 5.61763L13.2591 5.50243C12.6999 5.37603 12.4207 5.31283 12.1959 5.14243C11.9711 4.97203 11.8279 4.71362 11.5399 4.19682L11.2775 3.72642C10.264 1.90881 9.75758 1 9 1C8.24242 1 7.73603 1.90881 6.72245 3.72642"
      stroke={color} strokeWidth="2" strokeLinecap="round" {...props}/>
  </svg>
);

export default StarDropdownIcon;


